export default __webpack_public_path__ + "static/media/chevron_rightKeto.1e98571e.svg";